"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfessionalBlank = exports.ProfessionalRequestDTOSchema = exports.ProfessionalDTO = exports.ProfessionalDTOSchema = exports.ProfessionalSchema = exports.ProfessionalBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var OtherInfo_1 = require("./OtherInfo");
var Position_1 = require("./Position");
var User_1 = require("./User");
exports.ProfessionalBaseSchema = OtherInfo_1.OtherInfoSchema.extend({
    // Should positions be connected to documents in DB?
    Positions: zod_1.z.array(Position_1.PositionRequestDTOSchema).default([]),
    YachtQualifications: zod_1.z.array(zod_1.z.string()).optional(),
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
});
exports.ProfessionalSchema = exports.ProfessionalBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.ProfessionalDTOSchema = exports.ProfessionalSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelDTOFields), { UserId: (0, ObjectId_1.ObjectIdString)('Invalid user id') }));
exports.ProfessionalDTO = {
    convertFromModel: function (model) {
        var _a, _b;
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            SRB: model.SRB,
            CWB: model.CWB,
            TRB: model.TRB,
            OtherQualifications: model.OtherQualifications,
            Experience: model.Experience,
            AreaOfOperations: model.AreaOfOperations,
            CurrentBusiness: model.CurrentBusiness,
            JobTitle: model.JobTitle,
            YachtQualifications: model.YachtQualifications,
            TypeOfBusiness: model.TypeOfBusiness,
            Position: model.Position,
            Positions: model.Positions,
            UserId: model.UserId._id ? (_a = model.UserId._id) === null || _a === void 0 ? void 0 : _a.toString() : (_b = model.UserId) === null || _b === void 0 ? void 0 : _b.toString(),
            User: (0, ObjectId_1.isPopulated)(model.UserId) ? User_1.UserDTO.convertFromModel(model.UserId) : undefined,
        };
        return dto;
    },
};
exports.ProfessionalRequestDTOSchema = exports.ProfessionalDTOSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields);
exports.ProfessionalBlank = {
    UserId: '',
    Positions: [],
    YachtQualifications: [],
    TypeOfBusiness: [],
};
//# sourceMappingURL=Professional.js.map